import pump from "../../../assets/ic_pump.png";
import level from "../../../assets/ic_level.png";
import flow from "../../../assets/ic_flow.png";
import multk from "../../../assets/ic_multk.png";
import pressure from "../../../assets/ic_pressure.png";

export const getDate = (dateTime) => {
  if (dateTime == null) return "";
  const date = dateTime.split(" ")[0];
  const [year, month, day] = date.split("-");
  return `${day}/${month}/${year.substring(2, 4)}`;
};

export const getTime = (dateTime) => {
  if (dateTime == null) return "";
  const time = dateTime.split(" ")[1];
  return time.substring(0, 5);
};

export const getIcon = (type) => {
  switch (String(type)) {
    case "1":
    case "11":
      return level;
    case "2":
    case "13":
      return pump;
    case "3":
    case "4":
    case "9":
    case "10":
      return flow;
    case "5":
    case "7":
    case "8":
      return pressure;
    case "6":
      return multk;
    default:
      return null;
  }
};

export const getReading = (type, reading, isOffline) => {
  switch (String(type)) {
    case "1":
    case "11":
      return (
        <>
          <span>Nível: </span>
          <span className={handleClassName(isOffline)}>{reading} m.c.a</span>
        </>
      );
    case "2":
    case "13":
      return (
        <>
          <span>Bomba: </span>
          {reading === "1.00" || reading === 1 ? (
            <span className={handleClassName(isOffline, "text-success")}>
              Ligada
            </span>
          ) : (
            <span className={handleClassName(isOffline, "text-danger")}>
              Desligada
            </span>
          )}
        </>
      );
    case "3":
    case "4":
    case "9":
    case "10":
      return (
        <>
          <span>Vazão: </span>
          <span className={handleClassName(isOffline)}>{reading} m³/h</span>
        </>
      );
    case "5":
      return (
        <>
          <span>Pressão: </span>
          <span className={handleClassName(isOffline)}>{reading} m.c.a</span>
        </>
      );
    case "6":
      return (
        <>
          <span>Corrente: </span>
          <span className={handleClassName(isOffline)}>{reading} A</span>
        </>
      );
    case "7":
      return (
        <>
          <span>PH: </span>
          <span className={handleClassName(isOffline)}>{reading}</span>
        </>
      );
    case "8":
      return (
        <>
          <span>Oxigênio: </span>
          <span className={handleClassName(isOffline)}>{reading}</span>
        </>
      );
    default:
      return null;
  }
};

const handleClassName = (isOffline, fontWeight = "fw-normal") => {
  return `${isOffline ? "disconnected" : fontWeight}`;
};

export const getConnectionStatus = (isOffline) => {
  return isOffline ? (
    <span className="disconnected">Desconectado</span>
  ) : (
    <span className="connected">Conectado</span>
  );
};
